export default __webpack_public_path__ + "static/media/icon-comms-light.e01fc6ae.svg";